// RTS EXPRESS Official Logo Component
// Official brand identity - DO NOT MODIFY
// Uses the official gold shield with stylized R logo

export default function GoldShieldLogo({ className = "w-10 h-12" }) {
  return (
    <img 
      src="/rts-logo-official.jpeg" 
      alt="RTS Express" 
      className={className}
      style={{ 
        objectFit: 'contain',
        filter: 'none' // No modifications to original
      }}
    />
  );
}
